import React, { useState } from "react";
import "../sign-up/sign-up.css";
import "./forget-password.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../../assets/images/Gato-logo.svg";
import { ForgetPasswordAPI } from "api-services";
import { CircularProgress } from "@mui/material";

function ForgetPassword() {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.authentication.loading);

  const [username, setUsername] = useState("");

  const [showErrorMessage, setShowErrorMessage] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  //   Form validation
  const [errors, setErrors] = useState({});

  //   Setting button text
  const buttonText = "Submit";

  const handleValidation = () => {
    let tempErrors = {};
    let isValid = true;

    if (username.length <= 0) {
      tempErrors["username"] = true;
      isValid = false;
    }

    setErrors({ ...tempErrors });
    return isValid;
  };
  const handleForgetPassword = async (e) => {
    e.preventDefault();

    setShowErrorMessage("");
    setShowSuccessMessage(false);

    let data = {
      email: username,
    };

    if (handleValidation()) {
      ForgetPasswordAPI(
        dispatch,
        data,
        navigateToDashboard,
        setShowErrorMessage,
        clearFields
      );
    }
  };

  const navigateToDashboard = () => {
    setShowSuccessMessage(true);
  };
  const clearFields = () => {
    setUsername("");
  };

  return (
    <div>
      <div className="wrap-register sigin">
        <div className="container-fluid text-center">
          <div className="row">
            <div className="col-md-6 p-0">
              <div className="bg-common">
                <div className="auth-left-panel">
                  <div className="auth-left-content">
                    <a href={window.globalConfig.mainWebsiteUrl}  rel="noreferrer">
                      <img src={Logo} alt="Gato Systems" className="cred-logo" />
                    </a>
                    <h1 className="auth-left-title">
                      Flexible APIs for{" "}
                      <span className="auth-left-gradient">Modern{"\n"}Infrastructure</span>.
                    </h1>
                    <p className="auth-left-desc">
                      Access GATO&apos;s complete product ecosystem through a secure,
                      high-performance API layer built to handle your most critical
                      data workloads. Designed for rapid deployment and maximum
                      uptime, our unified API endpoints give your developers the
                      flexibility to build, test, and deploy custom solutions
                      effortlessly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 bg-trans">
              <a href="/#introduction" className="auth-close-btn">&times;</a>
              <div className="auth-right-panel">
                <div className="col-md-12 col-lg-6 p-lg-5">
                  <h3 className="cred-form-title text-start">
                    Forgot Password
                  </h3>
                  <p className="cred-form-desc text-start">
                    Remember your password?
                    <Link to="/authentication/sign-in"> Sign In</Link>
                  </p>
                  <form className="row" onSubmit={handleForgetPassword}>
                    <div className="col-12 mb-3">
                      <input
                        type="email"
                        className="form-control"
                        id="username"
                        placeholder="Email Address*"
                        value={username}
                        onChange={(e) => {
                          setUsername(e.target.value);
                        }}
                      />
                      {errors?.username && (
                        <p className="text-red">Email cannot be empty.</p>
                      )}
                    </div>

                    <div className="d-grid gap-2 col-12 mx-auto mb-3">
                      {showErrorMessage != "" && (
                        <p className="text-error text-center">
                          {showErrorMessage}
                        </p>
                      )}
                      {showSuccessMessage && (
                        <p className="text-green text-center">
                          Instructions to reset your password were sent to your
                          registered email.
                        </p>
                      )}

                      <button
                        className="btn cred-btn-contact"
                        onClick={handleForgetPassword}
                        disabled={loading}
                      >
                        {loading ? (
                          <CircularProgress
                            size={25}
                            color="white"
                            className="loaderbtn"
                          />
                        ) : (
                          buttonText
                        )}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="footer row justify-content-md-center">
                  <div className="col-md-12 col-lg-9 bg-trans p-0">
                    <div className="wrap-footer-inners">
                      <hr />
                      <Link to="/privacypolicy" target="_blank">
                        Privacy Policy
                      </Link>
                      <Link to="/termsofuse" target="_blank">
                        Terms of Use
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
